module.exports = __webpack_public_path__ + "static/simulate-short_v2-970f3565c68945acfbd5a5ff9e8ccbd6.mp4";